export default __webpack_public_path__ + "static/mediopollosolopapa-4336098bf9fe34383eab0791cb1e76f5.jpg";